import React from "react";
import styled from "styled-components";

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #121212;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-size: cover;
  mix-blend-mode: overlay;
  background-image: url("http://i.giphy.com/5Zesu5VPNGJlm.gif");
`;

const ErrorCode = styled.div`
  font-family: degular;
  font-size: 144px;
  height: 100vh;
  color: white;
  width: 100%;
  display: flex;
  backgorund-position: center;
  align-items: center;
  background-size: cover;
  justify-content: center;
`;

function Error404() {
  return (
    <Container>
      <Background />
      <ErrorCode>404</ErrorCode>
    </Container>
  );
}

export default Error404;
